// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2315": "7a519249","2530": "e96a97f9","6339": "bf8fd994","6974": "e56bceb8",}[chunkId] + ".css"
}